<template>
  <div class="form-repeater-item">
    <div class="form-repeater-item__sort-handle" v-if="sortable">
      <span uk-icon="icon: grid"></span>
    </div>
    <div class="form-repeater-item__fields" :class="{ 'inline-fields': inlineFields }">
      <div class="form-repeater-item__actions">
        <slot name="actions">
          <div class="remove-action">
            <template v-if="pendingRemoval">
              <button
                type="button"
                class="uk-icon-button uk-button-danger"
                @click="finishRemove"
              >
                <span uk-icon="icon: check"></span></button>
              <button
                type="button"
                class="uk-icon-button uk-button-default"
                @click="cancelRemove"
              >
                <span uk-icon="icon: close"></span></button>
            </template>
            <button
              v-else
              type="button"
              class="uk-icon-button uk-button-danger"
              @click="startRemove"
            >
              <span uk-icon="icon: trash"></span></button>
          </div>
        </slot>
      </div>
      <slot v-bind:item="modelValue"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiFormRepeaterItem',

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    modelValue: {
      type: Object,
      required: true,
      // FormRepeater expects all items to have an `id` property.
      default() {
        return {
          id: null,
        }
      },
    },
    inlineFields: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      pendingRemoval: false,
    }
  },

  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.$emit('update:modelValue', this.modelValue)
      },
    },
  },

  methods: {
    startRemove() {
      this.pendingRemoval = true
    },
    cancelRemove() {
      this.pendingRemoval = false
    },
    finishRemove() {
      this.$emit('remove', this.modelValue)
    },
  },
}
</script>

<style lang="scss">
.form-repeater-item {
  background: #fff;
  display: flex;
  margin: 1rem 0;
  padding: 10px;
  position: relative;
}

.form-repeater-item__sort-handle {
  align-self: center;
  cursor: pointer;
  margin-right: 1em;
}

.form-repeater-item__actions {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-bottom: .5em;
}

.form-repeater-item .remove-action button + button {
  margin-left: 4px;
}

@include media(">=tablet") {
  .form-repeater-item {
    background: transparent;
    padding: 0;
  }

  .form-repeater-item__actions {
    margin-bottom: 1rem;
  }

  .form-repeater-item .inline-fields .form-repeater-item__actions {
    margin-bottom: 0;
    margin-left: 10px;
    order: 999;
    position: relative;
    right: 0;
    top: 0;
  }
}
</style>
